export default function AgencyDirective() {
  return {
    template: require('./agency.html'),
    scope: {
      auditId: '=',
      audit: '=',
      agency: '=',
      agencies: '=',
      auditTypes: '=',
      coordinators: '=',
      objectDataTypes: '=',
      refreshAudit: '=',
      isEdit: '=',
    },
    controller: 'AgencyController',
    controllerAs: 'agencyVM',
    bindToController: true,
    replace: true
  };
}
